import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import type { TagType } from 'lumen/models/custom-tag-definition';
import { TAG_TYPE_TRANSLATIONS } from 'lumen/utils/constants/property-tags';

interface SettingsCustomPropertyTagsCellsTdTagTypeSignature {
  Args: {
    value: TagType;
  };
}

export default class SettingsCustomPropertyTagsCellsTdTagType extends Component<SettingsCustomPropertyTagsCellsTdTagTypeSignature> {
  @service declare intl: Services['intl'];

  get label(): string {
    return this.intl.t(TAG_TYPE_TRANSLATIONS[this.args.value]);
  }

  <template>{{this.label}}</template>
}
